export enum BaseAssignmentDateStatusEnum {
  OPEN = 'open',
  SUBMITTED = 'submitted',
  ACCEPTED = 'accepted',
  CANCELED = 'canceled',
  ABSENCE = 'absent',
  CORRECTED_BY_CUSTOMER = 'corrected_by_customer',
  CORRECTED_BY_PSP = 'corrected_by_psp',
  AUTOMATICALLY_ACCEPTED = 'automatically_accepted',
  INCOMPLETE = 'incomplete',
  VERIFICATION_NEEDED = 'verification_needed',
}
